import { inject, Injectable, NgZone } from '@angular/core';
import { AnalyticsProvider } from './analytics-provider';
import { AnalyticsEvent } from './analytics-event';
import { AnalyticsTrackerProvider } from './analytics-tracker-provider';
import { AnalyticsUser } from './analytics-user';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsManager {
  private readonly ngZone = inject(NgZone);
  private readonly providers: AnalyticsProvider[] = [];
  private readonly trackerProviders: AnalyticsTrackerProvider[] = [];

  registerProvider(provider: AnalyticsProvider): void {
    // Some providers need to be initialized outside Angular's zone
    this.ngZone.runOutsideAngular(() => provider.initialize());
    this.providers.push(provider);
  }

  registerTrackerProvider(provider: AnalyticsTrackerProvider): void {
    // Some providers need to be initialized outside Angular's zone
    this.ngZone.runOutsideAngular(() => provider.initialize());
    this.trackerProviders.push(provider);
  }

  activate(providerId: string): void {
    this.providers.filter((provider) => provider.id === providerId).forEach((provider) => provider.activate());
    this.trackerProviders.filter((provider) => provider.id === providerId).forEach((provider) => provider.activate());
  }

  deactivate(providerId: string): void {
    this.providers.filter((provider) => provider.id === providerId).forEach((provider) => provider.deactivate());
    this.trackerProviders.filter((provider) => provider.id === providerId).forEach((provider) => provider.deactivate());
  }

  sendEvent<T extends Record<string, unknown>>(event: AnalyticsEvent<T>): void {
    this.trackerProviders.forEach((provider) => {
      provider.sendEvent(event);
    });
  }

  setUser(user: AnalyticsUser): void {
    this.trackerProviders.forEach((provider) => {
      provider.user.set(user);
    });
  }
}
